(function () {
  var SNF_SCRIPT_URLS = [
    'https://d1pwxj66mjl9h0.cloudfront.net/angular/runtime.js',
    'https://d1pwxj66mjl9h0.cloudfront.net/angular/polyfills.js',
    'https://d1pwxj66mjl9h0.cloudfront.net/angular/scripts.js',
    'https://d1pwxj66mjl9h0.cloudfront.net/angular/main.js'
  ];

  function isValidSnfProductCode(code) {
    if (!code) return false;
    code = String(code).trim();
    if (code.indexOf('TC-') !== 0) return false;
    if (code === 'TC--') return false;
    var parts = code.split('-');
    return parts.length >= 3 && parts[1] !== '' && parts[parts.length - 1] !== '';
  }

  function getScope(root) {
    return root && root.querySelectorAll ? root : document;
  }

  function parseSnfConfig(root) {
    var scope = getScope(root);
    var script = scope.querySelector('script.snf-product-config');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseSnfCodeFromComment(root) {
    var scope = getScope(root);
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_COMMENT, null);
    var node;
    while ((node = walker.nextNode())) {
      var match = (node.textContent || '').match(/snf-product-code:\s*(TC-[^\s]+)/);
      if (match) return match[1];
    }
    return null;
  }

  function applyConfigToWidget(widget, config) {
    if (!widget || !config || !isValidSnfProductCode(config.productCode)) return false;
    widget.setAttribute('product-code', config.productCode);
    if (config.productImageUrl) {
      widget.setAttribute('product-image-url', config.productImageUrl);
    }
    if (config.productUrl) {
      widget.setAttribute('product-url', config.productUrl);
    }
    if (config.productPrice != null && config.productPrice !== '') {
      widget.setAttribute('product-price', String(config.productPrice));
    }
    if (config.currency) {
      widget.setAttribute('enterprise-currency', config.currency);
    }
    widget.style.display = '';
    widget.style.marginLeft = widget.style.marginLeft || '10px';
    return true;
  }

  function findOrCreateWidgetHost(root, config) {
    var scope = getScope(root);
    var widget = scope.querySelector('[fmf-widget-manager]');
    if (widget) return widget;

    if (!config || !isValidSnfProductCode(config.productCode)) return null;

    var hostRow =
    scope.querySelector('variant-button .m-product-option--label[style*="flex-end"]') ||
    scope.querySelector('.m-product-option--label') ||
    scope.querySelector('.product-form__input') ||
    scope.querySelector('.product-option-size') ||
    scope.querySelector('.size-selector') ||
    scope.querySelector('[data-option-name="Size"]');
    if (!hostRow) {
      var sizeGuide = scope.querySelector('[data-open-sizeguide]:not(.m\\:hidden)');
      if (!sizeGuide) {
        sizeGuide = scope.querySelector('[data-open-sizeguide]');
      }
      hostRow = sizeGuide ? sizeGuide.closest('.m-product-option--label') : null;
    }
    if (!hostRow) {
  hostRow =
    scope.querySelector('.size-chart-button-t-shirt-bra') ||
      scope.querySelector('.size-guide') ||
      scope.querySelector('.size-chart') ||
      scope.querySelector('.product-size-guide');
  }
  console.log('[SNF] Host Row:', hostRow);
  console.log('[SNF] Config:', config);
    if (!hostRow) return null;

    widget = document.createElement('div');
    widget.setAttribute('fmf-widget-manager', '');
    widget.className = 'foxkit-sizechart-button m:inline-flex m:items-center;';
    applyConfigToWidget(widget, config);
    hostRow.appendChild(widget);
    return widget;
  }

  function isWidgetMounted(widget) {
    return !!(widget && widget.querySelector('.snfwidgetapp'));
  }

  function activateWidgetElement(widget) {
    if (!widget) return;
    widget.removeAttribute('fmf-widget-manager');
    window.setTimeout(function () {
      widget.setAttribute('fmf-widget-manager', '');
    }, 0);
  }

  function loadFreshSnfScripts() {
    var bust = Date.now();
    return SNF_SCRIPT_URLS.reduce(function (promise, url) {
      return promise.then(function () {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = url + '?snf=' + bust;
          script.async = true;
          script.onload = function () {
            resolve();
          };
          script.onerror = function () {
            reject(new Error('SNF script failed: ' + url));
          };
          document.body.appendChild(script);
        });
      });
    }, Promise.resolve());
  }

  function waitForMount(widgets, timeoutMs) {
    var deadline = Date.now() + (timeoutMs || 1200);
    return new Promise(function (resolve) {
      function tick() {
        var ok =
          widgets.length > 0 &&
          widgets.every(function (w) {
            return isWidgetMounted(w);
          });
        if (ok) {
          resolve(true);
          return;
        }
        if (Date.now() >= deadline) {
          resolve(false);
          return;
        }
        window.requestAnimationFrame(tick);
      }
      tick();
    });
  }

  function prepareWidgets(root) {
    var config =
      parseSnfConfig(root) ||
      (function () {
        var code = parseSnfCodeFromComment(root);
        return code ? { productCode: code } : null;
      })();

    if (!config) return [];

    var widgets = Array.prototype.slice.call(
      getScope(root).querySelectorAll('[fmf-widget-manager]')
    );

    if (!widgets.length) {
      var created = findOrCreateWidgetHost(root, config);
      if (created) widgets = [created];
    }

    widgets.forEach(function (widget) {
      applyConfigToWidget(widget, config);
      activateWidgetElement(widget);
    });

    return widgets;
  }

  function bootstrapSnfAfterDomSwap(root) {
    var widgets = prepareWidgets(root);
    if (!widgets.length) return Promise.resolve(false);

    return waitForMount(widgets, 400).then(function (mounted) {
      if (mounted) return true;

      return loadFreshSnfScripts()
        .then(function () {
          widgets = prepareWidgets(root);
          return waitForMount(widgets, 1200);
        })
        .then(function (mountedAfterReload) {
          if (mountedAfterReload) return true;

          return new Promise(function (resolve) {
            window.setTimeout(function () {
              widgets = prepareWidgets(root);
              waitForMount(widgets, 1200).then(resolve);
            }, 500);
          });
        })
        .catch(function (err) {
          console.error('[SNF] bootstrap failed after AJAX', err);
          return false;
        });
    });
  }

  function ensureSnfAndReinit(root) {
    return bootstrapSnfAfterDomSwap(root);
  }

  window.bootstrapSnfAfterDomSwap = bootstrapSnfAfterDomSwap;
  window.ensureSnfSizeCalculator = ensureSnfAndReinit;
  window.reinitSnfSizeCalculator = ensureSnfAndReinit;

  document.addEventListener('DOMContentLoaded', function () {
    bootstrapSnfAfterDomSwap(document);
  });

  document.addEventListener('ProductVariantDataUpdated', function () {
    window.setTimeout(function () {
      bootstrapSnfAfterDomSwap(document);
    }, 300);
  });

  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      bootstrapSnfAfterDomSwap(document);
    }, 300);
  });

  document.addEventListener('pack:swapped', function () {
    window.setTimeout(function () {
      bootstrapSnfAfterDomSwap(document);
    }, 200);
  });
})();
